import {
  ADD_TAGS,
  ADD_TAGS_FAILED,
  ADD_TAGS_SUCCESS,
  CONNECT_USER_TO_PRISM,
  CONNECT_USER_TO_PRISM_FAILED,
  CONNECT_USER_TO_PRISM_SUCCESS,
  CREATE_ADMIN,
  CREATE_ADMIN_FAIL,
  CREATE_ADMIN_SUCCESS,
  CREATE_USER,
  CREATE_USER_FAIL,
  CREATE_USER_SUCCESS,
  DELETE_PENDING_USERS,
  DELETE_PENDING_USERS_FAILED,
  DELETE_PENDING_USERS_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAILED,
  DELETE_USER_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_FAIL,
  GET_CUSTOMERS_SUCCESS,
  GET_USER_META_TAGS,
  GET_USER_META_TAGS_FAILED,
  GET_USER_META_TAGS_SUCCESS,
  HIDE_ADD_TAG_MODAL,
  HIDE_BULK_MODAL,
  HIDE_CREATE_MODAL,
  HIDE_DELETE_PENDING_USERS_MODAL,
  HIDE_DELETE_USER_MODAL,
  HIDE_REMOVE_USER_TAG_MODAL,
  HIDE_USER_BLOCK_STATUS_MODAL,
  OPEN_DELETE_PENDING_USERS_MODAL,
  OPEN_DELETE_USER_MODAL,
  OPEN_USER_BLOCK_STATUS_MODAL,
  REMOVE_USER_TAG,
  REMOVE_USER_TAG_FAILED,
  REMOVE_USER_TAG_SUCCESS,
  RESET_USER_META_TAGS,
  SEND_INVITE,
  SEND_INVITE_FAIL,
  SEND_INVITE_SUCCESS,
  SET_SELECTED_CUSTOMER,
  SET_USER_BLOCK_STATUS,
  SET_USER_BLOCK_STATUS_FAILED,
  SET_USER_BLOCK_STATUS_SUCCESS,
  SHOW_ADD_TAG_MODAL,
  SHOW_BULK_MODAL,
  SHOW_CREATE_MODAL,
  SHOW_REMOVE_USER_TAG_MODAL,
  UPDATE_CUSTOMER_DATA,
  UPDATE_CUSTOMER_DATA_FAILED,
  UPDATE_CUSTOMER_DATA_SUCCESS,
} from "store/people/actionTypes"

export const getCustomers = params => ({
  type: GET_CUSTOMERS,
  payload: { params },
})

export const getCustomersSuccess = customers => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: customers,
})

export const resetCustomers = () => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: {},
})

export const getCustomersFail = error => ({
  type: GET_CUSTOMERS_FAIL,
  payload: error,
})

export const sendInvite = params => ({
  type: SEND_INVITE,
  payload: params,
})

export const sendInviteSuccess = () => ({
  type: SEND_INVITE_SUCCESS,
})

export const sendInviteFail = error => ({
  type: SEND_INVITE_FAIL,
  payload: error,
})

export const createUser = user => ({
  type: CREATE_USER,
  payload: user,
})

export const createUserSuccess = () => ({
  type: CREATE_USER_SUCCESS,
  payload: {},
})

export const createUserFail = error => ({
  type: CREATE_USER_FAIL,
  payload: error,
})

export const createAdmin = admin => ({
  type: CREATE_ADMIN,
  payload: admin,
})

export const createAdminSuccess = () => ({
  type: CREATE_ADMIN_SUCCESS,
  payload: {},
})

export const createAdminFail = error => ({
  type: CREATE_ADMIN_FAIL,
  payload: error,
})

export const showCreateModal = () => ({
  type: SHOW_CREATE_MODAL,
  payload: {},
})

export const hideCreateModal = () => ({
  type: HIDE_CREATE_MODAL,
  payload: {},
})

export const showBulkModal = () => ({
  type: SHOW_BULK_MODAL,
  payload: {},
})

export const hideBulkModal = () => ({
  type: HIDE_BULK_MODAL,
  payload: {},
})

export const showAddTagModal = () => ({
  type: SHOW_ADD_TAG_MODAL,
  payload: {},
})

export const hideAddTagModal = () => ({
  type: HIDE_ADD_TAG_MODAL,
  payload: {},
})

export const addTags = params => ({
  type: ADD_TAGS,
  payload: params,
})

export const addTagsSuccess = response => ({
  type: ADD_TAGS_SUCCESS,
  payload: response,
})

export const addTagsFailed = error => ({
  type: ADD_TAGS_FAILED,
  payload: error,
})

export const getUserMetaTags = params => ({
  type: GET_USER_META_TAGS,
  payload: params,
})

export const getUserMetaTagsSuccess = response => ({
  type: GET_USER_META_TAGS_SUCCESS,
  payload: response,
})

export const getUserMetaTagsFailed = error => ({
  type: GET_USER_META_TAGS_FAILED,
  payload: error,
})

export const resetUserMetaTags = () => ({
  type: RESET_USER_META_TAGS,
  payload: {},
})

export const updateCustomerData = params => ({
  type: UPDATE_CUSTOMER_DATA,
  payload: params,
})

export const updateCustomerDataSuccess = response => ({
  type: UPDATE_CUSTOMER_DATA_SUCCESS,
  payload: response,
})

export const updateCustomerDataFailed = error => ({
  type: UPDATE_CUSTOMER_DATA_FAILED,
  payload: error,
})

export const setSelectedCustomer = params => ({
  type: SET_SELECTED_CUSTOMER,
  payload: params,
})

export const connectUserToPrism = params => ({
  type: CONNECT_USER_TO_PRISM,
  payload: params,
})

export const connectUserToPrismSuccess = response => ({
  type: CONNECT_USER_TO_PRISM_SUCCESS,
  payload: response,
})

export const connectUserToPrismFailed = error => ({
  type: CONNECT_USER_TO_PRISM_FAILED,
  payload: error,
})

export const showRemoveUserTagModal = () => ({
  type: SHOW_REMOVE_USER_TAG_MODAL,
  payload: {},
})

export const hideRemoveUserTagModal = () => ({
  type: HIDE_REMOVE_USER_TAG_MODAL,
  payload: {},
})

export const removeUserTag = params => ({
  type: REMOVE_USER_TAG,
  payload: params,
})

export const removeUserTagSuccess = response => ({
  type: REMOVE_USER_TAG_SUCCESS,
  payload: response,
})

export const removeUserTagFailed = error => ({
  type: REMOVE_USER_TAG_FAILED,
  payload: error,
})

export const deletePendingUsers = params => ({
  type: DELETE_PENDING_USERS,
  payload: params,
})

export const deletePendingUsersSuccess = response => ({
  type: DELETE_PENDING_USERS_SUCCESS,
  payload: response,
})

export const deletePendingUsersFailed = error => ({
  type: DELETE_PENDING_USERS_FAILED,
  payload: error,
})

export const openDeletePendingUsersModal = () => ({
  type: OPEN_DELETE_PENDING_USERS_MODAL,
  payload: {},
})

export const hideDeletePendingUsersModal = () => ({
  type: HIDE_DELETE_PENDING_USERS_MODAL,
  payload: {},
})

export const deleteUser = params => ({
  type: DELETE_USER,
  payload: params,
})

export const deleteUserSuccess = response => ({
  type: DELETE_USER_SUCCESS,
  payload: response,
})

export const deleteUserFailed = error => ({
  type: DELETE_USER_FAILED,
  payload: error,
})

export const openDeleteUserModal = () => ({
  type: OPEN_DELETE_USER_MODAL,
  payload: {},
})

export const hideDeleteUserModal = () => ({
  type: HIDE_DELETE_USER_MODAL,
  payload: {},
})

export const setUserBlockStatus = params => ({
  type: SET_USER_BLOCK_STATUS,
  payload: params,
})

export const setUserBlockStatusSuccess = response => ({
  type: SET_USER_BLOCK_STATUS_SUCCESS,
  payload: response,
})

export const setUserBlockStatusFailed = error => ({
  type: SET_USER_BLOCK_STATUS_FAILED,
  payload: error,
})

export const openUserBlockStatusModal = () => ({
  type: OPEN_USER_BLOCK_STATUS_MODAL,
  payload: {},
})

export const hideUserBlockStatusModal = () => ({
  type: HIDE_USER_BLOCK_STATUS_MODAL,
  payload: {},
})
